import { PERSONAL_DATA } from "../../common/constants";
import { GET_ORDER_LIST_SUCCESS, UPDATE_BASKET, UPDATE_PUBLIC_BUYER, UPDATE_ORDER_OPERATION_DATA } from "../action-types/order";

const initialState = {
    orders: [],
    basketProducts: [],
    basketTrainings: [],
    publicBuyer: null,
    operation: {
        selectedPaymentMethod: null,
        entity: null,
        nIPC: null,
        nIPCCountry: { code: "Portugal", name: "Portugal" },
        selectedInvoiceData: PERSONAL_DATA
    }
};

const orderReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_ORDER_LIST_SUCCESS:
            return {
                ...state,
                orders: action.orders.orders
            };
        case UPDATE_BASKET:
            return {
                ...state,
                basketProducts: action.products,
                basketTrainings: action.trainings
            };
        case UPDATE_ORDER_OPERATION_DATA:
            return {
                ...state,
                operation: action.operation
            };
        case UPDATE_PUBLIC_BUYER:
            return {
                ...state,
                publicBuyer: action.publicBuyer
            };
        default:
            return state;
    }
}

export default orderReducer;